function rebindBulkBuyEvents() {
  document.addEventListener('click', function (event) {
    // Check if the clicked element (or one of its ancestors) matches 'label.bulk-buy'
    const label = event.target.closest('label.bulk-buy');
    if (!label) return;
    const qty = label.getAttribute('data-qty');
    if (typeof window.updatePriceDisplay === 'function') {
      window.updatePriceDisplay(qty);
    } else {
      console.warn("updatePriceDisplay not defined when label clicked");
    }
  });
}

window.updatePriceDisplay = function(Value) {
    if (isNaN(Value) || Value <= 0) {
        console.warn('Invalid quantity:', Value);
        return;
    }

    const mainAddToBasketContainer = document.querySelector('.main-add-to-basket');
    const priceSections = document.querySelectorAll('.price_quantity_wrapper .price__container, product-info .price__container, .main-add-to-basket .price__container');

    const discountTwo = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-two')) || 0 : 0;
    const discountThree = mainAddToBasketContainer ? Number(mainAddToBasketContainer.getAttribute('data-discount-three')) || 0 : 0;

    const updateQuantityInputs = (Value) => {
        document.querySelectorAll('.price_quantity_wrapper .quantity__input').forEach(input => input.value = Value);
        document.querySelectorAll('.updated-product-quantity').forEach(input => input.setAttribute("value", Value));
        document.querySelectorAll('.price-per-item__container .quantity__button').forEach(button => {
           if (Value >= 2) {
            button.classList.remove('disabled');
          }
        });
    };

    // Takes the single-bottle price, not the line total. Rounds the same way as bulk-buy.liquid and the NL cart:
    // 2 pack = discount off the total, nearest cent; 3+ = discount off each bottle, rounded down (applyUnitCentDiscount)
    const getDiscountedPrice = (unitPrice, Value) => {
        if (Value > 1 && Value < 3) return Math.round(Math.round(unitPrice * 100) * Value * (100 - discountTwo) / 100 + 1e-6) / 100;
        if (Value > 2) return applyUnitCentDiscount(unitPrice, Value, discountThree);
        return unitPrice * Value;
    };

    // Hoisted out of the price loop below: it used to run once per price container, so it
    // was skipped entirely whenever none matched and the cart got the stale quantity.
    updateQuantityInputs(Value);

    const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
    const bulkBuy = document.querySelector('.main-bulk-buy');
    if (checkedInput && !bulkBuy) {
      let productWrapper = checkedInput.closest(".product__info-wrapper"); 
      let priceContainer = productWrapper.querySelector(".price__container");
      let selectedVariantPrice = parseFloat(checkedInput.getAttribute("product-option-variant-price")) / 100;
      let selectedVariantMrp = parseFloat(checkedInput.getAttribute("product-option-variant-mrp")) / 100;
      // alert(priceContainer.value);
      if (selectedVariantPrice && selectedVariantMrp > selectedVariantPrice) {
        priceContainer.innerHTML = ` <span class="price-item price-item--sale price-item--last">${formatPrice(selectedVariantPrice * Value)}</span>
        <s class="price-item price-item--compare price-item--regular">${formatPrice(selectedVariantMrp * Value)}</s>`
      } else {
        priceContainer.innerHTML = ` <span class="price-item price-item--sale price-item--last">${formatPrice(selectedVariantPrice * Value)}</span>`  
      }

      const totalRegularPrice = getProductPriceBasedOnQuantity(Value, selectedVariantPrice);
      updatePerServingPrice(priceContainer, totalRegularPrice, Value);
      // Update comfort points based on discounted or regular price
      updateCustomerPoints(Value, totalRegularPrice, totalRegularPrice);
    } else {

      priceSections.forEach(priceContainer => {
        const regularPrice = parseFloat(priceContainer.getAttribute('data-regular-price')) / 100;
        const compareAtPrice = parseFloat(priceContainer.getAttribute('data-compare-price')) / 100;

        const hasBulkDiscount = mainAddToBasketContainer && (
          mainAddToBasketContainer.hasAttribute('data-discount-two') ||
          mainAddToBasketContainer.hasAttribute('data-discount-three')
        );

        // Retrieve the stored flag from sessionStorage
        const xvdStored = sessionStorage.getItem('xvd_found');

        let isBulkApplicable;
        if (xvdStored === 'true') {
          // xvd was detected earlier in the session
          isBulkApplicable = false;
        } else {
          // Normal bulk logic
          isBulkApplicable = Value > 1 && hasBulkDiscount;
        }

        const totalRegularPrice = getProductPriceBasedOnQuantity(Value, regularPrice);
        let totalCompareAtPrice;
        if (isBulkApplicable) {
            // When bulk discount is applied, compare-at = base price * qty
            totalCompareAtPrice = compareAtPrice ? getProductPriceBasedOnQuantity(Value, regularPrice) : null;
        } else {
            // Else, use actual compare-at * qty
            totalCompareAtPrice = compareAtPrice ? getProductPriceBasedOnQuantity(Value, compareAtPrice) : null;
        }

        let finalPrice = totalRegularPrice;
        if (isBulkApplicable) {
            finalPrice = getDiscountedPrice(regularPrice, Value);
        }

        priceContainer.innerHTML = '';

        if (Value == 1) {
          // Handle quantity = 1
          if (compareAtPrice && compareAtPrice > regularPrice) {
            priceContainer.innerHTML = `
              <span class="price-item price-item--sale price-item--last">${formatPrice(regularPrice)}</span>
              <s class="price-item price-item--compare price-item--regular">${formatPrice(compareAtPrice)}</s>
            `;
          } else {
            priceContainer.innerHTML = `
              <div class="price__regular">
                <span class="price-item price-item--regular">${formatPrice(regularPrice)}</span>
              </div>
            `;
          }
          } else if (Value > 1 && totalCompareAtPrice && Math.round(totalCompareAtPrice * 100) > Math.round(finalPrice * 100)) {

          // Show compare-at and regular for quantity > 1
          priceContainer.innerHTML = `
            <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
            <s class="price-item price-item--compare price-item--regular">${formatPrice(totalCompareAtPrice)}</s>
          `;
        } else if (finalPrice < totalRegularPrice) {
          // Discounted without compare-at
          priceContainer.innerHTML = `
            <span class="price-item price-item--sale price-item--last">${formatPrice(finalPrice)}</span>
            <s class="price-item price-item--regular">${formatPrice(totalRegularPrice)}</s>
          `;
        } else {
          // No discount or compare-at
          priceContainer.innerHTML = `
            <div class="price__regular">
              <span class="price-item price-item--regular">${formatPrice(totalRegularPrice)}</span>
            </div>
          `;
        }

        updatePerServingPrice(priceContainer, finalPrice, Value);

        // Update comfort points based on discounted or regular price
        updateCustomerPoints(Value, totalRegularPrice, finalPrice);
      });
    }
};

// Per-unit line under the main price (price-per-serving.liquid). It sits outside
// .price__container, which the block above rewrites wholesale, so it is re-worked here off the
// same final price. Scoped to the price block it belongs to, so the bulk tiles' own per-unit
// lines — fixed pack sizes, already correct — are left alone.
function updatePerServingPrice(priceContainer, finalPrice, quantity) {
    const line = priceContainer.closest('.price')?.parentElement?.querySelector(':scope > [data-price-per-serving]');
    if (!line) return;

    const servings = Number(line.getAttribute('data-servings')) || 0;
    const totalServings = servings * (Number(quantity) || 1);
    if (totalServings <= 0) return;

    // Truncated to the cent, the same integer divide price-per-serving.liquid does, so the line
    // never lands a cent away from the matching bulk tile.
    const perServing = Math.floor(Math.round(finalPrice * 100) / totalServings) / 100;
    const unit = line.getAttribute('data-serving-unit') || '';
    (line.querySelector('span') || line).textContent = `${formatPrice(perServing)} / ${unit}`;
}

function formatPrice(price) {
    // Ensure two decimals, then swap . and ,
    let parts = price.toFixed(2).split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1];
    // Add thousands separator (.)
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // Join with comma as decimal separator
    return `€${integerPart},${decimalPart}`;
}

function getProductPriceBasedOnQuantity(Value, unitPrice) {
    return unitPrice * Value;
}

// Multipack price for `qty` bottles, rounded exactly like bulk-buy.liquid, which is what the cart charges: the
// discount comes off EACH bottle in whole cents rounded down, then that bottle price is multiplied by the quantity
// (3 x 22,99 € at 25% off is 51,75 €, not the 51,73 € a discount off the total gives). Used for the 3+ pack.
// unitPrice and the return are euros; percent is a whole number such as 25. The small epsilon stops float noise
// (99.99999...) from flooring a whole cent away.
function applyUnitCentDiscount(unitPrice, qty, percent) {
    const unitCents = Math.round(unitPrice * 100);
    const discountCents = percent ? Math.floor((unitCents * percent) / 100 + 1e-6) : 0;
    return ((unitCents - discountCents) * qty) / 100;
}

function updateCustomerPoints(Value, totalRegularPrice, finalPrice) {
  const customerPointsElement = document.getElementById('comfortPoints');
  // Use the discounted price if there is a discount, else use the regular price
  let priceToUse = (finalPrice < totalRegularPrice) ? finalPrice : totalRegularPrice;
  let updatedPrice = priceToUse; // Convert from cents to euros
  const ceilCustomerPoints = Math.floor(updatedPrice);
  if (customerPointsElement) {
      customerPointsElement.innerText = `${ceilCustomerPoints}`;
  }
}

// Function to update comfort points based on bulk buy //
  const customerPointsElement = document.getElementById('comfortPoints');
  const bulkBuyInputs = document.querySelectorAll('.bulkbuy-input-element');
  if(bulkBuyInputs){
    bulkBuyInputs.forEach(input => {
      input.addEventListener('change', function() {
        const points = this.getAttribute('data-points');
        if (customerPointsElement) {
          customerPointsElement.innerText = `${points}`;
        }
      });
    });
  }
  rebindBulkBuyEvents();


/***variant Updation code */
let lastUrl = location.href;
function highlightVariantImage() {
  const variantSelects = document.querySelector("variant-selects, .variant-selects");
  if (!variantSelects) return;

  const checkedInput = variantSelects.querySelector("input[type='radio']:checked");
  if (!checkedInput) return;

  const selectedValue = checkedInput.value.trim();
  if (!selectedValue) return;

  // Remove old highlights
  document.querySelectorAll(".variant-image-found").forEach(el =>
    el.classList.remove("variant-image-found")
  );

  // Highlight elements directly matching via data attributes
  const matchingElements = document.querySelectorAll("[data-variant-thumbnail-alt], [data-media-variant]");
  matchingElements.forEach(el => {
    const alt = el.getAttribute("data-variant-thumbnail-alt") || "";
    const media = el.getAttribute("data-media-variant") || "";
    if (alt.includes(selectedValue) || media.includes(selectedValue)) {
      el.classList.add("variant-image-found");
    }
  });

  // Highlight closest .owl-item for each .media_modal_wrapper
  document.querySelectorAll(".media_modal_wrapper").forEach(wrapper => {
    const variantAlt = wrapper.getAttribute("data-variant-thumbnail-alt") || "";
    const owlItem = wrapper.closest(".owl-item");

    if (!owlItem) return;

    if (variantAlt.includes(selectedValue)) {
      owlItem.classList.add("variant-image-found");
    } else {
      owlItem.classList.remove("variant-image-found");
    }
  });
}

// NOTE: Media (main slider + thumbnail slider + modal) is now rebuilt together
// from a single fetch inside product-info.js `updateMedia()` on variant change.
// This function used to do a SECOND fetch + wrapper replacement, which ran after
// the native update and caused the media to blink/rebuild twice. It is kept as a
// no-op so any remaining callers (e.g. the minified global.min.js change handler)
// do nothing instead of triggering that duplicate rebuild.
window.refreshScrollingAt = function () {
  /* intentionally left blank – see note above */
};


// Toggle visibility of bulk-buy options based on selected variant
function toggleBulkBuyVisibilityAndSelectFirst(e, targetID) {
  const el = e?.target || e;
  if (!el || !(el instanceof Element)) return;

  // Only respond to checked input
  if (el.tagName === 'INPUT' && !el.checked) return;

  const checkedInputvariantId = targetID;
  const wrapper = el.closest('.product__info-wrapper') || document;

  let firstVisibleBulkBuy = null;

  wrapper.querySelectorAll('.bulk-buy-inner').forEach(inner => {
    const bulkBuyVariantId = inner.getAttribute('data-variant-bulk-id')?.trim();

    if (checkedInputvariantId === bulkBuyVariantId) {
      inner.classList.remove("hidden");
      if (!firstVisibleBulkBuy) firstVisibleBulkBuy = inner;
    } else {
      inner.classList.add("hidden");
    }
  });

  // Select the first input inside the first visible bulk-buy-inner
  if (firstVisibleBulkBuy) {
    // Don't clobber an existing selection (e.g. restored from ?qty=); a newly
    // revealed block has nothing checked, so it still falls through to the first.
    const firstInput =
      firstVisibleBulkBuy.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked') ||
      firstVisibleBulkBuy.querySelector('input[type="radio"], input[type="checkbox"]');
    if (firstInput) {
      firstInput.checked = true;
      // Optionally, trigger change event if your logic depends on it
      firstInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  highlightVariantImage();
  //refreshScrollingAtc();
  rebindBulkBuyEvents();
}

// Auto-run on page load
// Trigger bulk-buy visibility if variant is pre-selected
const checkedInput = document.querySelector('variant-selects input[type="radio"]:checked');
console.log("checkedInput" , checkedInput);
if (checkedInput) {
  
  const variantId = checkedInput.getAttribute('product-option-variant-id');
  console.log("variantId",variantId);
  toggleBulkBuyVisibilityAndSelectFirst(checkedInput, variantId);
} else {
  console.warn("❌ No variant is checked on page load.");
}

// Run other variant-related logic
if (
  location.href.includes('/products/') &&
  document.body.classList.contains('body-has-variants')
) {
  window.runVariantUpdateLogic?.();
}

setTimeout(() => {
  rebindBulkBuyEvents();
}, 300);

// On URL change, re-run variant logic
const observer = new MutationObserver(() => {
  const currentUrl = location.href;
  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl;
    window.runVariantUpdateLogic?.();
  }
});
observer.observe(document.body, { childList: true, subtree: true });

// Product Reviews 
const reviewElement = document.querySelectorAll('#goAllReviews');

reviewElement?.forEach((each) => {
  each.addEventListener('click', (event) => {
    event.preventDefault();
    const reviewHref = each.getAttribute('href');
    const reviewWrapper = document.querySelector(reviewHref);  
    if (reviewWrapper) {
      smoothScrollToElement(reviewWrapper, 160)
    }
  });
})

function smoothScrollToElement(element, offset = 0) {
  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;
  const scrollPosition = absoluteElementTop - offset;
  
  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth'
  });
}

// Mega sale
document.querySelectorAll('.mega-sale-copy-button').forEach(function (button) {
  button.addEventListener('click', function () {
    const discountCode = this.dataset.discountCode;
    const tooltip = this.querySelector('.tooltiptext');

    if (!discountCode) return;

    // Copy to clipboard
    navigator.clipboard.writeText(discountCode).then(() => {
      // Show tooltip
      tooltip.classList.add('active');

      // Hide tooltip after 2 seconds
      setTimeout(() => {
        tooltip.classList.remove('active');
      }, 2000);
    });
  });

});
const knowMoreButton = document.querySelector('#mega_sale_know_more');
const megaSaleCloseButton = document.querySelector('.mega-sale-close-button')
const offerBoxContent = document.querySelector('#know_more_content');
const offerBox = document.querySelector('.offer-box__container');
knowMoreButton?.addEventListener('click', () => {
  if (offerBox) offerBox.classList.add('hidden');
  if (offerBoxContent) offerBoxContent.classList.remove('hidden');
})

megaSaleCloseButton?.addEventListener('click', () => {
  if (offerBox) offerBox.classList.remove('hidden');
  if (offerBoxContent) offerBoxContent.classList.add('hidden');
})

window.updateMegaSalePrice = function(value) {
  const megaSaleBox = document.querySelector('.mega-sale__offer_box');
  if (megaSaleBox) {
    const megaSalePrice = parseInt(megaSaleBox.getAttribute('data-discounted-price'));
    const originalPrice = parseInt(megaSaleBox.getAttribute('data-original-price'));
    const megaSalePriceElement = megaSaleBox?.querySelectorAll('.mega-sale-price');
    const megaSaleSavePriceElement = megaSaleBox?.querySelector('.mega-sale-extra-saving-price');

    const totalOriginalPrice = (originalPrice * value) / 100
    const discountedPrice = (megaSalePrice * value) / 100

    const savedPrice = totalOriginalPrice - discountedPrice
    const totalSaved = savedPrice
    const finalSavedAmount = formatPrice(totalSaved);
    const finalDiscountedPrice = formatPrice(discountedPrice);
    megaSalePriceElement?.forEach((each)=> each.textContent = finalDiscountedPrice);
    megaSaleSavePriceElement.textContent = finalSavedAmount;
    console.log(finalDiscountedPrice);
  }
}

document.querySelectorAll('[id^="BuyNowButton-"]').forEach(button => {
  button.addEventListener("click", async function () {
    const productForm = button.closest('product-form');
    const form = productForm.querySelector('form');

    if (!form) return;

    button.setAttribute('disabled', true);

    const formData = new FormData(form);

    try {
      // Add product to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      // Get updated cart
      const cartResponse = await fetch('/cart.js');
      const cartState = await cartResponse.json();

      // Call your existing function
      if (typeof window.handleGiftProduct === 'function') {
        await window.handleGiftProduct(cartState);
      }

      // Redirect after gift logic completes
      window.location.href = '/checkout';

      setTimeout(() => {
        button.removeAttribute('disabled');
      }, 500);

    } catch (err) {
      console.error('Buy Now error:', err);
      button.removeAttribute('disabled');
    }
  });
});

// Multipack <-> ?qty= sync. The param is only written while the tiles are visible.
(function () {
  const QTY_PARAM = 'qty';
  const PACK_INPUT = 'input[name="bulk_buy_qty"]';

  // ":visible" test — catches display:none on the element or any ancestor.
  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  // Tiles of the shown variant block, or [] when the multipack isn't on screen.
  function getPackLabels() {
    if (location.pathname.indexOf('/products/') === -1) return [];

    const wrapper = document.querySelector('.main-bulk-buy');
    if (!isVisible(wrapper)) return [];

    const shownInner = Array.prototype.find.call(
      wrapper.querySelectorAll('.bulk-buy-inner'),
      (inner) => !inner.classList.contains('hidden')
    );
    if (!shownInner) return [];

    return Array.prototype.slice.call(shownInner.querySelectorAll('label.bulk-buy[data-qty]'));
  }

  function findLabel(labels, qty) {
    return Array.prototype.find.call(labels, (label) => label.getAttribute('data-qty') === String(qty));
  }

  function writeQtyToUrl(qty) {
    const url = new URL(window.location.href);
    if (url.searchParams.get(QTY_PARAM) === String(qty)) return;
    url.searchParams.set(QTY_PARAM, qty);
    // replaceState, not pushState: switching packs shouldn't stack up history entries.
    window.history.replaceState(window.history.state, '', url.toString());
  }

  function applyQtyFromUrl() {
    const labels = getPackLabels();
    if (!labels.length) return; // No multipack on screen -> leave the URL alone.

    const requested = new URLSearchParams(window.location.search).get(QTY_PARAM);
    // Matched against the tiles actually rendered, which on this store are 1 / 2 / 3.
    // Anything else (4, 0, "abc", "03", missing) falls back to the 1 pack.
    const target = findLabel(labels, requested) || findLabel(labels, 1) || labels[0];
    const qty = target.getAttribute('data-qty');

    const input = target.querySelector(PACK_INPUT);
    if (input && !input.checked) {
      target.click(); // real click, so every existing listener stays in the loop
    } else if (input && qty !== '1') {
      // bulk-buy-qty.js already ticked it; the rest of the page is still priced for 1 pack.
      input.dispatchEvent(new Event('change', { bubbles: true })); // loyalty points
      if (typeof window.updatePriceDisplay === 'function') window.updatePriceDisplay(qty);
    }

    writeQtyToUrl(qty);
  }

  // Every pack change — click or programmatic — mirrored back into the URL.
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input || typeof input.matches !== 'function' || !input.matches(PACK_INPUT) || !input.checked) return;

    const label = input.closest('label.bulk-buy[data-qty]');
    if (!label || !getPackLabels().length) return;

    writeQtyToUrl(label.getAttribute('data-qty'));
  });

  let applied = false;
  function runOnce() {
    if (applied) return;
    applied = true;
    applyQtyFromUrl();
  }

  // DOMContentLoaded so body.found_xvd_permeter is applied first; timeout is the fallback.
  document.addEventListener('DOMContentLoaded', runOnce);
  setTimeout(runOnce, 0);
})();

// Customer related Slider
const slider = document.querySelector(".customer-related-slider");

if (slider) {
  $(slider).owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 1300,

    // Blink / Fade Effect
    animateOut: "fadeOut",
    animateIn: "fadeIn",

    smartSpeed: 500,
    mouseDrag: false,
    touchDrag: false
  });
}